'use client';

import { useTranslationStore } from '@/stores';
import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  EpErrorMessage,
  EpStepContent,
} from '../../../../components/HookFormComponents/components';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { EpDatepicker } from '../EpDatePicker';

type QuestionsAnswersProps = {
  questionId: number;
  questionDescription: string;
  required: boolean;
  maxLength: number;
  questionReferLibraryId: number;
  questionTypeId: number;
  questionsLibrary: boolean;
  questionCategoryIncident: number;
  order: number;
  answerRequiredId: number | null;
  questionRequiredId: number | null;
  answers?: {
    answerId: number;
    answerDescription: string;
  }[];
};

const EpQuestionDate = ({
  QuestionsAnswers,
  index,
}: {
  QuestionsAnswers: QuestionsAnswersProps;
  index: string;
}) => {
  const { getValues, setValue, control } = useFormContext();
  const { i18n } = useTranslation();
  const QuestionDate = getValues(`questions.${index}`);

  if (
    QuestionDate ||
    !QuestionDate?.inputValue ||
    QuestionDate.inputValue?.length === 0
  ) {
    const question = {
      ...QuestionDate,
      inputValue: QuestionDate.inputValue || [''],
    };
    setValue(`questions.${index}`, question);
  }

  const datepickerOnChangeFunc = (date: string) => {
    QuestionDate.inputValue = [date];
    setValue(`questions.${index}`, QuestionDate);
  };

  const { translations } = useTranslationStore();

  return (
    <EpStepContent.Label
      label={`${QuestionsAnswers.questionDescription} ${QuestionsAnswers.required ? '*' : ''}`}
      required={QuestionsAnswers.required}
    >
      <Controller
        name={`questions.${index}` as const}
        control={control}
        rules={{
          required: {
            value: QuestionsAnswers.required,
            message: `${QuestionsAnswers.questionDescription} ${t(
              translations['global'],
              '* Required Fied',
            )}`,
          },
          validate: (value) => {
            return (
              !QuestionsAnswers.required ||
              (value && value.inputValue[0] !== '') ||
              t(translations['global'], '* Required Fied')
            );
          },
        }}
        render={({ field }) => (
          <EpDatepicker
            datepickerId={
              QuestionsAnswers.questionDescription.replace(/[^A-Z]+/gi, '_') +
              index.replace(/[^0-9]+/gi, '_')
            }
            cultureCode={i18n.language}
            datepickerOnChangeFunc={datepickerOnChangeFunc}
            datepickerInputName={field.name}
            {...(QuestionsAnswers.questionId === 29 && {
              datepickerMinView: 'months',
              datepickerView: 'months',
              datepickerDateFormat: 'MM/yyyy',
              isManualEntry: false,
            })}
            reactHookFormValue={field.value.inputValue}
            reactHookFormGetValues={getValues}
            isInlineDatepicker={false}
            inputHasIcon
            inputIsFullWidth
          />
        )}
      />
      <EpErrorMessage inputName={`questions.${index}`} />
    </EpStepContent.Label>
  );
};

export default memo(EpQuestionDate);
